import React, { useState } from 'react'
import moment from 'moment'
import { Modal, Button } from 'react-bootstrap'

const DeliveryStatus = ({ existingDeliveryEvent, deliveryRequired, consigneeLocationInfo, getDataNew, appointmentBeingScheduled, crudActionInProgress, setCrudActionInProgress }) => {



    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        if (crudActionInProgress) {
            return
        }
        setShow(true)
    };


    if (appointmentBeingScheduled === 'Delivery') {
        return (
            <div className="alert alert-secondary border-dark mt-2 d-flex justify-content-center" role="alert">
                <strong>Updating ...</strong> &nbsp;<div className="spinner-border" role="status"></div>
            </div>
        )
    }


    if (existingDeliveryEvent.length) {
        return (
            existingDeliveryEvent.map(function (event, index) {
                return (
                    <div className="alert alert-success mt-2 border border-success mt-2" role="alert" key={index}>
                        Scheduled Delivery Appt:<br />
                        <strong>{moment(event.StartTime).format("MMMM D")}</strong><br />
                        <strong>{moment(event.StartTime).format("hh:mm a")} </strong> to <strong>{moment(event.EndTime).format("hh:mm a")} </strong><br />
                        <div className="d-flex flex-row-reverse">
                            <span className="link" onClick={handleShow}>Cancel</span>
                        </div>

                        <Modal show={show} onHide={handleClose}>
                            {/* <Modal.Header closeButton>
                                <Modal.Title>Cancel Delivery Appointment?</Modal.Title>
                            </Modal.Header> */}
                            <Modal.Body>Would you like to cancel the delivery appointment?</Modal.Body>
                            <Modal.Footer>
                                <Button variant="primary" onClick={() => { orchestrateDeleteDockAppts() }}>
                                    Yes
                                </Button>
                                <Button variant="secondary" onClick={handleClose}>
                                    No
                                </Button>

                            </Modal.Footer>
                        </Modal>
                    </div>
                )
            })

        )
    } else if (deliveryRequired) {
        return (
            <div className="alert alert-warning border border-warning mt-2" role="alert">Delivery appointment required.</div>
        )
    } else if (!deliveryRequired) {
        return (
            <div className="alert alert-secondary border border-secondary mt-2" role="alert"><small>No delivery appointment required.</small></div>
        )
    } else {
        return (<div className="alert alert-warning border border-warning  mt-2" role="alert">Error, unknown appointment status.</div>)
    }

    async function deleteDockSchedulerAppt(appointment) {
        var myHeaders = new Headers();

        myHeaders.append("x-api-key", "vdhy8wwjUJrwhxFpfuECTiAW");
        myHeaders.append("content-type", "application/json;charset=UTF-8");


        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(appointment),
            redirect: 'follow'
        };

        await fetch("https://api.shippersedge.com/schedule/shipment/", requestOptions)
            .then(response => response.text())
            .then(result => window.location.reload())
            .catch(error => console.log('error', error));
        return true
    }

    async function orchestrateDeleteDockAppts() {
        if (existingDeliveryEvent && existingDeliveryEvent.length) {
            existingDeliveryEvent.forEach(appointment => {
                appointment.requestType = "eventRemove"
                appointment.responsibleUser = "carrier"
                appointment.locationId = consigneeLocationInfo.dockLocationId
                // console.log('appt', appointment)
                deleteDockSchedulerAppt(appointment)

            });
        }
    }

}

export default DeliveryStatus
